import "./appcontent.css"

const webcontent = () =>{
    return (
        
                      <div className="container mt-4">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="saptitle erptitle">Mobile App Service</div>
                <p className="erppara"> 
                A mobile app (or mobile application) is a software application developed specifically for use on small, wireless computing devices, such as smartphones and tablets, rather than desktop or laptop computers.
                </p>
                <ul className="websub erpul">
	<li className="webpoints">Mobile apps, vital in today's digital age, are categorized as web-based, native (platform-specific), or hybrid (combining both). </li>
    <li className="webpoints">They impact daily life, from social networking to business and productivity.</li>
                </ul>
                
                    </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <img src="https://www.designveloper.com/wp-content/uploads/2021/05/istock-1187869343.jpg" alt="erp" className="img-erp img-shadow" />
                </div>
            </div>
        </div>
 
        
    )
}

export default webcontent